import React, { useEffect, useState } from 'react'
import { Text, TextVariant } from '@mprolab/uikit'
import { useTheme } from 'styled-components'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

/**
 * When an intention expires. Absent for 0 ("never"), a plain date while
 * distant, and a live countdown inside the final hour — the moment it
 * actually changes what somebody should do.
 */
const ExpiryNote: React.FC<{ expiresAt?: number }> = ({ expiresAt }) => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  const [, tick] = useState(0)

  const withinHour = Boolean(expiresAt && expiresAt * 1000 - Date.now() < 3600_000)
  useEffect(() => {
    if (!withinHour) return undefined
    const h = setInterval(() => tick((n) => n + 1), 1000)
    return () => clearInterval(h)
  }, [withinHour])

  if (!expiresAt) return null
  const msLeft = expiresAt * 1000 - Date.now()
  if (msLeft <= 0) {
    return (
      <Text variant={TextVariant.TEXT_XS_REGULAR} color={colors.red}>
        {t('marketplace.expired')}
      </Text>
    )
  }
  if (msLeft < 3600_000) {
    const m = Math.floor(msLeft / 60000)
    const s = Math.floor((msLeft % 60000) / 1000)
    return (
      <Text variant={TextVariant.TEXT_XS_REGULAR} color={colors.yellow ?? colors.cyan}>
        {t('marketplace.expiresIn', { time: `${m}m ${s}s` })}
      </Text>
    )
  }
  return (
    <Text variant={TextVariant.TEXT_XS_REGULAR} color={colors.gray6}>
      {t('marketplace.expiresOn', {
        date: dayjs.unix(expiresAt).format('YYYY-MM-DD HH:mm')
      })}
    </Text>
  )
}

export default ExpiryNote
